const DEFAULT_DESIGN = {
  pageBackgroundColor: '#ffffff',
  surveyBackgroundColor: '#ffffff',
  borderColor: '#d9d9d9',

  headerColor: '#28456a',
  textColor: '#262626',
  questionColor: '#28456a',
  descriptionColor: '#767676',
  disclaimerColor: '#767676',
  linkColor: '#28456a',

  inputBorderColor: '#d9d9d9',
  inputBackgroundColor: '#ffffff',
  inputTextColor: '#262626',
  inputSelectedBorderColor: '#28456a',
  inputSelectedBackgroundColor: '#28456a',
  inputSelectedTextColor: '#ffffff',
  inputFocusColor: '#767676',
  inputErrorColor: '#db3734',

  buttonColor: '#28456a',
  buttonTextColor: '#ffffff',
  acceptButtonColor: '#28456a',
  acceptButtonTextColor: '#ffffff',
  declineButtonColor: '#d9d9d9',
  declineButtonTextColor: '#262626',
  cornerRadius: 6,

  progressBarBackgroundColor: '#d9d9d9',
  progressBarColor: '#28456a',
};

const DARK_DESIGN = {
  pageBackgroundColor: '#ffffff',
  surveyBackgroundColor: '#2d2d2d',
  borderColor: '#697075',

  headerColor: '#F2F2F3',
  textColor: '#D9D9D9',
  questionColor: '#F2F2F3',
  descriptionColor: '#D9D9D9',
  disclaimerColor: '#D9D9D9',
  linkColor: '#2099f4',

  inputBorderColor: '#d9d9d9',
  inputBackgroundColor: '#666666',
  inputTextColor: '#D9D9D9',
  inputSelectedBorderColor: '#2099f4',
  inputSelectedBackgroundColor: '#2099f4',
  inputSelectedTextColor: '#ffffff',
  inputFocusColor: '#767676',
  inputErrorColor: '#db3734',

  buttonColor: '#2099f4',
  buttonTextColor: '#ffffff',
  acceptButtonColor: '#2099f4',
  acceptButtonTextColor: '#ffffff',
  declineButtonColor: '#d9d9d9',
  declineButtonTextColor: '#262626',
  cornerRadius: 2,

  progressBarBackgroundColor: '#d9d9d9',
  progressBarColor: '#2099f4',
};

const THEMES = {
  default: DEFAULT_DESIGN,
  dark: DARK_DESIGN,
  custom: {},
};

module.exports = {
  THEMES,
};
